/* eslint-disable react/no-array-index-key */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import classNames from 'classnames';
import { Text } from '@nerdwallet/currency';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import _ from 'lodash';
import baseStyles from '@nerdwallet/base-styles/styles.module.css';
import Row from '../row/row';

import parseMarkdownLinks from '../../lib/parse-md-links';

import './bulleted-list.less';

const BulletedList = ({
  anchorId,
  bullets,
  copyStyle,
  header,
  isModule,
  parseLinks,
  type,
  mobileFullWidth,
  size,
}) => {
  const processCopyStyle = (style) => baseStyles[style] || style;
  const linkParser = (content) =>
    parseLinks ? parseMarkdownLinks(content, false) : content;

  const itemClasses = classNames([
    'bulleted-list__item',
    processCopyStyle(copyStyle),
  ]);

  const list = (
    <Fragment>
      {header && (
        <Text component="h4" bold>
          {header}
        </Text>
      )}
      <ul
        id={anchorId}
        className={classNames(
          `bulleted-list__type-${type}`,
          'bulleted-list__list'
        )}
      >
        {[].concat(bullets).map((bullet, index) => (
          <li className={itemClasses} key={index}>
            {linkParser(bullet)}
          </li>
        ))}
      </ul>
    </Fragment>
  );
  let standardWidth = true;
  if (mobileFullWidth && size !== 'lg') {
    standardWidth = false;
  }
  return isModule ? (
    <Row
      centeredInParent
      standardMaxWidths={standardWidth}
      className={classNames({
        'bulleted-list__full-width': !standardWidth,
      })}
    >
      {list}
    </Row>
  ) : (
    list
  );
};

BulletedList.displayName = 'BulletedList';

BulletedList.propTypes = {
  anchorId: PropTypes.string,
  bullets: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.element])
  ).isRequired,
  copyStyle: PropTypes.oneOf([
    'copy-h1',
    'copy-h2',
    'copy-h3',
    'copy-h4',
    'copy-h5',
    'copy-p1',
    'copy-p2',
    'text-default',
    'text-small',
  ]).isRequired,
  isModule: PropTypes.bool,
  header: PropTypes.string,
  parseLinks: PropTypes.bool,
  type: PropTypes.oneOf(['default', 'check', 'none']),
  mobileFullWidth: PropTypes.bool,
  size: PropTypes.string,
};

BulletedList.defaultProps = {
  copyStyle: 'copy-p2',
  type: 'default',
  parseLinks: true,
};

export default connect(
  createStructuredSelector({
    size: _.property('mediaQuery'),
  })
)(BulletedList);
